module.exports = __webpack_public_path__ + "dfc36e08337007fdcf079d1a0079d143.png";